import { CustomBuilderComponents } from '@/helpers/enums';

export const vimeoGalleryBuilderConfigs = {
  name: CustomBuilderComponents.VIMEO_GALLERY,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/film.svg',
  inputs: [
    {
      name: 'videos',
      type: 'list',
      copyOnAdd: false,
      subFields: [
        {
          name: 'videoId',
          type: 'string',
          required: true,
        },
      ],
    },
  ],
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
};
